import { Controller } from "@hotwired/stimulus"
import { formValidation, plugins } from "formvalidation"
import Bootstrap3 from "formvalidation/plugins/Bootstrap3"

export default class extends Controller {
  static targets = [
    "form",
    "criticalPriorityField",
    "criticalPriorityLabel",
    "highPriorityField",
    "highPriorityLabel",
    "lowPriorityField",
    "lowPriorityLabel",
    "ticketTypeIdField",
    "ticketTypeIdLabel",
    "statusIdField",
    "statusIdLabel",
    "queueIdField",
    "queueIdLabel",
    "defaultCompanyIdField",
    "defaultCompanyIdLabel",
    "submitButton"
  ]

  connect() {
    this.setupFormValidation()

    $(this.criticalPriorityFieldTarget).on("select2:select select2:unselect", this.validateField.bind(this, "criticalPriority"))
    $(this.highPriorityFieldTarget).on("select2:select select2:unselect", this.validateField.bind(this, "highPriority"))
    $(this.lowPriorityFieldTarget).on("select2:select select2:unselect", this.validateField.bind(this, "lowPriority"))

    $(this.ticketTypeIdFieldTarget).on("select2:select select2:unselect", this.validateField.bind(this, "ticketTypeId"))
    $(this.statusIdFieldTarget).on("select2:select select2:unselect", this.validateField.bind(this, "statusId"))
    $(this.queueIdFieldTarget).on("select2:select select2:unselect", this.validateField.bind(this, "queueId"))
    $(this.defaultCompanyIdFieldTarget).on("select2:select select2:unselect", this.validateField.bind(this, "defaultCompanyId"))
  }

  setupFormValidation() {
    this.fv = formValidation(
      this.formTarget,
      {
        plugins: {
          bootstrap3: new Bootstrap3(),
          trigger: new plugins.Trigger({
            event: "blur"
          })
        },
        fields: {
          criticalPriority: {
            selector: '[name="integrations_bms[critical_priority_id]"',
            validators: {
              notEmpty: { message: "Selecting a critical priority is required." },
            }
          },
          highPriority: {
            selector: '[name="integrations_bms[high_priority_id]"',
            validators: {
              notEmpty: { message: "Selecting a high priority is required." },
            }
          },
          lowPriority: {
            selector: '[name="integrations_bms[low_priority_id]"',
            validators: {
              notEmpty: { message: "Selecting a low priority is required." },
            }
          },
          ticketTypeId: {
            selector: '[name="integrations_bms[ticket_type_id]"',
            validators: {
              notEmpty: { message: "Selecting a ticket type is required." },
            }
          },
          statusId: {
            selector: '[name="integrations_bms[status_id]"',
            validators: {
              notEmpty: { message: "Selecting a status is required." },
            }
          },
          queueId: {
            selector: '[name="integrations_bms[queue_id]"',
            validators: {
              notEmpty: { message: "Selecting a queue is required." },
            }
          },
          defaultCompanyId: {
            selector: '[name="integrations_bms[default_company_id]"',
            validators: {
              notEmpty: { message: "Selecting an account is required." },
            }
          }
        }
      }
    )

    this.fv.on("core.field.invalid", (field) => this.toggleLabel(field, true))
    this.fv.on("core.field.valid", (field) => this.toggleLabel(field, false))
  }

  validateField(field) {
    // Trigger the validate so the `core.field.valid/invalid`
    // callback can run and update the label color
    this.fv.validateField(field)
    this.toggleButtonDisable()
  }

  toggleLabel(field, invalid) {
    // Same red used by `formValidation`
    this[`${field}LabelTarget`].style.color = invalid ? "#E74C3C" : null
  }

  toggleButtonDisable() {
    // Not running this.fv.validate here to prevent the
    // form fields from all being validated and turning red
    const allFilledOut = (
      this.criticalPriorityFieldTarget.value.length > 0 &&
      this.highPriorityFieldTarget.value.length > 0 &&
      this.lowPriorityFieldTarget.value.length > 0 &&
      this.ticketTypeIdFieldTarget.value.length > 0 &&
      this.statusIdFieldTarget.value.length > 0 &&
      this.queueIdFieldTarget.value.length > 0 &&
      this.defaultCompanyIdFieldTarget.value.length > 0
    )

    this.submitButtonTarget.disabled = !allFilledOut
  }
}
